import { formatRaceDateString } from '@mobi/utils/date'

export const getRaceLink = ({
  meetingId,
  raceNumber,
  meetingDate,
  code,
  meetingSeq,
  product,
  raceSeq,
  isFOO,
}: {
  meetingDate: string
  meetingId?: string
  raceNumber?: string | number
  code?: string
  meetingSeq?: string | number
  product?: string
  raceSeq?: string | number
  isFOO?: boolean
}): string => {
  const date = formatRaceDateString(meetingDate)
  return isFOO
    ? `/fobracing/propositions/${product}/${code}/${raceSeq}?selectionDate=${date}&meetingSeq=${meetingSeq}`
    : `/tote/meetings/${meetingId}/${raceNumber}?date=${date}`
}
